module.exports = __webpack_public_path__ + "media/components/videos_internal/dr_you_6_1-burger1-b5d6f4cf59ba0aba96032846cd6dca59.jpg";